<template>
	<content-loader :message="$t('initializing')" cover v-if="!userQueried" />
	<router-view v-else />
</template>

<script>
import storage from './store/storage';
import ContentLoader from './components/ContentLoader';

export default {
	inject: ['userRepository'],

	components: {
		ContentLoader
	},

	data () {
		return {
			userQueried: !storage.has('jwt')
		};
	},

	/**
	 * If a JWT token exists, loads the currently logged-in user before rendering
	 * the application.	If an error occurs, the user is logged out and redirected to
	 * the login page.
	 *
	 * @returns {void}
	 */
	async beforeMount () {
		if (storage.has('jwt')) {
			try {
				const token = storage.getToken();
				const user = await this.userRepository.getCurrent();
				this.$store.commit('auth/success', { token, user });
				this.userQueried = true;
			}
			catch (error) {
				await this.$store.dispatch('auth/logout');
				this.userQueried = true;
				this.$router.replace({ name: 'login' });
			}
		}
	}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap');
@import '~bootstrap/scss/bootstrap';
@import '~bootstrap-vue/src/index';
@import '~nprogress/nprogress';
@import '~vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss';

html,
body {
	font-family: 'Open Sans', "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}
</style>
